import { render, staticRenderFns } from "./OnDemandTotalWatchTime.vue?vue&type=template&id=71cfdf99&scoped=true&"
import script from "./OnDemandTotalWatchTime.vue?vue&type=script&lang=js&"
export * from "./OnDemandTotalWatchTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cfdf99",
  null
  
)

export default component.exports